module.exports = __webpack_public_path__ + "img/loading.038d9083.svg";